var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Triangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 5.4453125 C 22.777221 5.4453125 21.554396 6.0311566 20.878906 7.2011719 L 4.4863281 35.595703 C 3.1365571 37.935043 4.9043785 41 7.6054688 41 L 40.392578 41 C 43.094345 41 44.863843 37.935555 43.513672 35.595703 L 27.121094 7.2011719 C 26.445604 6.0311566 25.222779 5.4453125 24 5.4453125 z M 24 8.3515625 C 24.194221 8.3515625 24.388927 8.4681872 24.523438 8.7011719 L 40.916016 37.095703 C 41.181811 37.559058 40.927979 38 40.392578 38 L 7.6054688 38 C 7.0692359 38 6.8156575 37.56014 7.0839844 37.095703 L 23.476562 8.7011719 C 23.611073 8.4681872 23.805779 8.3515625 24 8.3515625 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Triangle);
export default __webpack_public_path__ + "static/media/icons8-triangle.43af81c7f47433706083938ccb499c17.svg";
export { ForwardRef as ReactComponent };